import configJson from '../config/config.json';

const appConfig = {
    lastUpdate: configJson.lastUpdate,
    environmentName: configJson.environmentName,
    apiUrl: configJson.apiUrl,
    aemUrl: configJson.aemUrl,
    logRocketId: configJson.logRocketId
};

const azureB2CMsal = {
    auth: {
        clientId: configJson.azureB2CConfig.auth.clientId,
        authority: configJson.azureB2CConfig.auth.authority,
        knownAuthorities: configJson.azureB2CConfig.auth.knownAuthorities,
        redirectUri: configJson.azureB2CConfig.auth.redirectUri,
        postLogoutRedirectUri: configJson.azureB2CConfig.auth.redirectUri
    },
    cache: {
        cacheLocation: configJson.azureB2CConfig.cache.cacheLocation,
        storeAuthStateInCookie: configJson.azureB2CConfig.cache.storeAuthStateInCookie
    },
    scope: {
        scopes: configJson.azureB2CConfig.scope.scopes
    }
};

const azureAdMsal = {
    auth: {
        clientId: configJson.azureADConfig.auth.clientId,
        authority: configJson.azureADConfig.auth.authority,
        redirectUri: configJson.azureADConfig.auth.redirectUri,
        postLogoutRedirectUri: configJson.azureADConfig.auth.redirectUri
    },
    cache: {
        cacheLocation: configJson.azureADConfig.cache.cacheLocation,
        storeAuthStateInCookie: configJson.azureADConfig.cache.storeAuthStateInCookie
    },
    scope: {
        scopes: configJson.azureADConfig.scope.scopes
    }
};

const configService = {
    appConfig,
    azureAdMsal,
    azureB2CMsal
};

export default configService;
